export type PdfJsModule = typeof import('pdfjs-dist');

/**
 * pdf.js 5 calls `Promise.withResolvers` (Chrome 119+, Safari 17.4+), in the
 * page and in its worker. Its legacy build carries the polyfill for both, so
 * browsers without the method get that build and browsers with it keep the
 * smaller modern one. It is the one thing pdf.js 5.4 needs that the supported
 * browsers lack: a pdf.js that needs more is to be checked here again.
 */
function hasPromiseWithResolvers(): boolean {
  return typeof Promise.withResolvers === 'function';
}

/** Worker from a CDN: it avoids Vite bundler / nginx MIME issues for local .mjs worker files. */
function pdfWorkerUrl(version: string, isLegacy: boolean): string {
  return `https://unpkg.com/pdfjs-dist@${version}/${isLegacy ? 'legacy/' : ''}build/pdf.worker.min.mjs`;
}

/** pdf.js of the build the browser can run, with its worker configured (must be set before `getDocument`). */
export async function loadPdfJs(): Promise<PdfJsModule> {
  const isLegacy = !hasPromiseWithResolvers();
  const pdfjsLib: PdfJsModule = isLegacy
    ? await import('pdfjs-dist/legacy/build/pdf.mjs')
    : await import('pdfjs-dist');
  if (typeof window !== 'undefined' && 'Worker' in window && !pdfjsLib.GlobalWorkerOptions.workerSrc) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl(pdfjsLib.version, isLegacy);
  }
  return pdfjsLib;
}
